// src/views/incidencias/IncidenciasListado.jsx
import React, { useEffect, useState } from "react";


import axios from "axios";
import { API_BASE } from "../../apiConfig";





export default function IncidenciasListado() {
  const [incidencias, setIncidencias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [filtroNivel, setFiltroNivel] = useState("TODOS");
  const [filtroEstado, setFiltroEstado] = useState("TODOS");
  const [busqueda, setBusqueda] = useState("");

  // ==============================
  // CARGAR INCIDENCI
  // ==============================
  const cargarIncidencias = async () => {
    try {
      setLoading(true);
      setError("");

      const res = await axios.get(`${API_BASE}/incidencias`);
      setIncidencias(res.data || []);
    } catch (err) {
      console.error("ERROR GET INCIDENCIAS:", err);
      setError("No se pudieron cargar las incidencias.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarIncidencias();
  }, []);

  // ==============================
  // ACTUALIZAR ESTADO
  // ==============================
  const actualizarEstado = async (idIncidencia, nuevoEstado) => {
    if (!idIncidencia) {
      alert("Error: incidencia sin ID válido.");
      console.error("ID inválido:", idIncidencia);
      return;
    }

    const confirm = window.confirm("¿Confirmas marcar esta incidencia como SOLUCIONADA?");
    if (!confirm) return;

    try {
      await axios.put(
        `${API_BASE}/incidencias/estado`,
        {
          id: idIncidencia,
          nuevoEstado,
        },
        {
          headers: { "Content-Type": "application/json" }
        }
      );

      alert("Incidencia marcada como SOLUCIONADA.");
      cargarIncidencias();
    } catch (err) {
      console.error("ERROR UPDATE INCIDENCIA:", err.response?.data || err);
      alert("Error al actualizar el estado.");
    }
  };

  // ==============================
  // KPI / CONTADORES
  // ==============================
  const total = incidencias.length;
  const criticas = incidencias.filter((i) => i.nivelRiesgo === "CRITICO").length;
  const medias = incidencias.filter((i) => i.nivelRiesgo === "MEDIO").length;
  const bajas = incidencias.filter((i) => i.nivelRiesgo === "BAJO").length;

  const noOperativos = incidencias.filter((i) =>
    (i.estadoNuevo || "").toUpperCase().includes("NO OPERATIVO")
  ).length;

  // ==============================
  // FILTROS
  // ==============================
  const incidenciasFiltradas = [...incidencias]
    .filter((i) => {
      if (filtroNivel !== "TODOS" && i.nivelRiesgo !== filtroNivel) return false;

      if (filtroEstado !== "TODOS" && (i.estadoNuevo || "").toUpperCase() !== filtroEstado)
        return false;

      if (busqueda.trim()) {
        const txt = busqueda.toLowerCase();
        const blob = [
          i.equipo,
          i.serie,
          i.marca,
          i.municipio,
          i.oficina,
          i.modulo,
          i.descripcion,
        ]
          .join(" ")
          .toLowerCase();

        if (!blob.includes(txt)) return false;
      }
      return true;
    })
    .sort((a, b) => {
      const da = new Date(a.fechaReporte || 0).getTime();
      const db = new Date(b.fechaReporte || 0).getTime();
      return db - da;
    });

  // ==============================
  // RENDER
  // ==============================
  return (
    <div className="max-w-6xl mx-auto">
      {/* Título */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-slate-800">Incidencias de Equipos</h1>
          <p className="text-sm text-slate-500 mt-1">
            Panel de alertas, refacciones y equipos que requieren atención inmediata.
          </p>
        </div>

        <button
          onClick={cargarIncidencias}
          className="px-4 py-2 rounded-lg bg-slate-900 text-white text-sm font-medium hover:bg-slate-700"
        >
          Actualizar
        </button>
      </div>

      {/* LOADING */}
      {loading && (
        <div className="flex justify-center items-center h-40">
          <div className="w-10 h-10 border-4 border-slate-300 border-t-blue-500 rounded-full animate-spin"></div>
        </div>
      )}

      {/* ERROR */}
      {!loading && error && (
        <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm">
          {error}
        </div>
      )}

      {/* TABLA & CONTROLES */}
      {!loading && !error && (
        <>
          {/* KPI CARDS */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
            <KpiCard label="Incidencias Totales" value={total} color="slate" />
            <KpiCard label="Críticas" value={criticas} color="red" />
            <KpiCard label="Riesgo Medio" value={medias} color="amber" />
            <KpiCard label="Equipos NO Operativos" value={noOperativos} color="blue" />
          </div>

          {/* TABLA */}
          <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
            {incidenciasFiltradas.length === 0 ? (
              <div className="p-8 text-center text-slate-500 text-sm">
                No hay incidencias que coincidan con los filtros.
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full text-sm">
                  <thead className="bg-slate-900 text-white">
                    <tr>
                      <th className="px-4 py-3 text-left">Equipo</th>
                      <th className="px-4 py-3 text-left">Serie</th>
                      <th className="px-4 py-3 text-left">Ubicación</th>
                      <th className="px-4 py-3 text-left">Estado</th>
                      <th className="px-4 py-3 text-left">Riesgo</th>
                      <th className="px-4 py-3 text-left">Refacciones</th>
                      <th className="px-4 py-3 text-left">Reemplazo</th>
                      <th className="px-4 py-3 text-left">Fecha</th>
                      <th className="px-4 py-3 text-left">Reportado por</th>
                      <th className="px-4 py-3 text-center">Acción</th>
                    </tr>
                  </thead>

                  <tbody>
                    {incidenciasFiltradas.map((inc) => {
                      const idIncidencia = inc.id;

                      return (
                        <tr key={idIncidencia} className="border-b last:border-b-0 border-slate-100 hover:bg-slate-50">
                          <td className="px-4 py-3">
                            <div className="font-semibold text-slate-800">{inc.equipo}</div>
                            <div className="text-xs text-slate-500">ID: {inc.idEquipo}</div>
                          </td>

                          <td className="px-4 py-3">
                            <div className="text-slate-800">{inc.serie}</div>
                            <div className="text-xs text-slate-500">{inc.marca}</div>
                          </td>

                          <td className="px-4 py-3 text-xs">
                            <div className="text-slate-800">{inc.oficina}</div>
                            <div className="text-slate-500">{inc.municipio}</div>
                            <div className="text-slate-400">Módulo: {inc.modulo}</div>
                          </td>

                          <td className="px-4 py-3">
                            <EstadoBadge estado={inc.estadoNuevo} />
                          </td>

                          <td className="px-4 py-3">
                            <NivelBadge nivel={inc.nivelRiesgo} />
                          </td>

                          <td className="px-4 py-3 text-xs">
                            {Array.isArray(inc.refacciones) && inc.refacciones.length > 0 ? (
                              <ul className="list-disc list-inside space-y-1">
                                {inc.refacciones.map((r, i) => (
                                  <li key={i}>{r}</li>
                                ))}
                              </ul>
                            ) : (
                              <span className="text-slate-400">Sin refacciones</span>
                            )}
                          </td>

                          <td className="px-4 py-3 text-xs">
                            {inc.reemplazo ? (
                              <span className="px-2 py-1 bg-red-100 text-red-700 rounded-full font-semibold">Requiere</span>
                            ) : (
                              <span className="px-2 py-1 bg-emerald-50 text-emerald-700 rounded-full">No requiere</span>
                            )}
                          </td>

                          <td className="px-4 py-3 text-xs">{formatearFecha(inc.fechaReporte)}</td>

                          <td className="px-4 py-3 text-xs">{inc.reportadoPor}</td>

                          <td className="px-4 py-3 text-center">
                            {inc.estadoNuevo !== "SOLUCIONADO" ? (
                              <button
                                className="px-3 py-1 text-xs rounded-lg bg-emerald-600 text-white hover:bg-emerald-700"
                                onClick={() => actualizarEstado(idIncidencia, "SOLUCIONADO")}
                              >
                                Marcar como Solucionado
                              </button>
                            ) : (
                              <span className="text-emerald-600 font-bold">✓ Solucionado</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

/* =============================
   COMPONENTES AUXILIARES
============================= */

function KpiCard({ label, value, color }) {
  const colorMap = {
    slate: "bg-slate-900 text-white",
    red: "bg-red-600 text-white",
    amber: "bg-amber-500 text-white",
    blue: "bg-sky-600 text-white",
  };

  return (
    <div className={`rounded-2xl p-4 shadow-sm border border-slate-200 ${colorMap[color]}`}>
      <div className="text-xs uppercase tracking-wide opacity-80">{label}</div>
      <div className="mt-2 text-2xl font-bold">{value}</div>
    </div>
  );
}

function NivelBadge({ nivel }) {
  const n = (nivel || "").toUpperCase();
  let classes = "inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold";

  if (n === "CRITICO") {
    classes += " bg-red-100 text-red-700 border border-red-200";
  } else if (n === "MEDIO") {
    classes += " bg-amber-100 text-amber-700 border border-amber-200";
  } else {
    classes += " bg-sky-100 text-sky-700 border border-sky-200";
  }

  return <span className={classes}>{n}</span>;
}

function EstadoBadge({ estado }) {
  const e = (estado || "").toUpperCase();
  let classes = "inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold";

  if (e.includes("NO OPERATIVO")) {
    classes += " bg-red-100 text-red-700 border border-red-200";
  } else if (e.includes("REPARACIÓN")) {
    classes += " bg-amber-100 text-amber-700 border border-amber-200";
  } else if (e.includes("SOLUCIONADO")) {
    classes += " bg-emerald-100 text-emerald-700 border border-emerald-200";
  } else {
    classes += " bg-slate-100 text-slate-700 border border-slate-300";
  }

  return <span className={classes}>{estado}</span>;
}

function formatearFecha(fecha) {
  if (!fecha) return "N/D";
  const d = new Date(fecha);
  if (isNaN(d.getTime())) return fecha;

  return d.toLocaleString("es-MX", {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}
